import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  componentName?: string;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const extra = {
      componentName: this.props.componentName,
      componentStack: errorInfo.componentStack,
    };

    if (typeof window !== 'undefined' && window.Rollbar) {
      window.Rollbar.error(error, extra);
    } else {
      console.error('[ErrorBoundary] Caught error:', error, extra);
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
